<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-3">
      <h4 class="font-weight-medium">{{ $t('routines.note_other') }}</h4>
      <Button
        v-if="!isEditing && canEditRoutine"
        icon="mdi-pencil"
        size="small"
        color="blueGrey"
        @click="isEditing = true"
      />
    </div>

    <v-chip v-if="!routine.notes && !isEditing" disabled small>{{
      $t('common.no_notes')
    }}</v-chip>
    <v-lazy v-else>
      <v-textarea
        v-model="notes"
        outlined
        dense
        no-resize
        hide-details
        auto-grow
        rows="4"
        :readonly="loading || !isEditing"
        :maxlength="$constants.routines.executions.notesMaxlength"
      />
    </v-lazy>
    <div class="d-flex justify-end mt-2">
      <div v-if="isEditing">
        <Button
          plain
          color="grey"
          :disabled="loading"
          :text="$t('common.button.cancel')"
          @click="cancelEditNotes"
        />
        <Button
          plain
          color="primary"
          :loading="loading"
          :disabled="loading"
          :text="$t('common.button.save')"
          @click="saveNotes"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Button from '@/components/UI/Button'
export default {
  name: 'Notes',
  components: {
    Button,
  },
  props: {
    routine: {
      required: true,
      type: Object,
    },
    loading: Boolean,
    canEditRoutine: Boolean,
  },

  data() {
    return {
      notes: this.routine?.notes ?? '',
      isEditing: false,
    }
  },

  methods: {
    cancelEditNotes() {
      this.notes = this.routine.notes || ''
      this.isEditing = false
    },

    saveNotes() {
      this.$emit('save', this.notes)
      this.isEditing = false
    },
  },
}
</script>
